import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { ConfigurationService } from 'Configuration/ConfigurationService';
import { FeatureFlag } from 'Environment/FeatureFlag';

export class AuthConfigAccessor {
	private configurationService: ConfigurationService;
	private workspaceConfiguration: WorkspaceConfiguration;

	public constructor(
		workspaceConfiguration: WorkspaceConfiguration,
		configurationService: ConfigurationService
	) {
		this.workspaceConfiguration = workspaceConfiguration;
		this.configurationService = configurationService;
	}

	public shouldIDPLogoffOnSessionExpiry(): boolean {
		return (
			this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
				FeatureFlag.EnableIdpLogoffOnSessionExpiry
			) &&
			this.workspaceConfiguration?.idpChainedLogoffOnTimeout?.enabled
				?.toString()
				.toLowerCase() === 'true'
		);
	}
}
